import { Component, inject, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OAuthErrorEvent, OAuthEvent, OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { tap } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { StorageService } from './core/services/storage.service';
import { GS1LoaderModule, GS1NotificationModule } from '@gs1france/gs1-components-library';

enum OAUTH_EVENT_TYPES {
  discovery_document_loaded = 'discovery_document_loaded',
  session_changed = 'session_changed'
}

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, GS1LoaderModule, GS1NotificationModule]
})
export class AppComponent implements OnDestroy {
  router = inject(Router);
  storageService = inject(StorageService);
  authService = inject(AuthService);
  oAuthService = inject(OAuthService);
  translateService = inject(TranslateService);

  constructor() {
    this.oAuthService.events
      .pipe(
        takeUntilDestroyed(),
        tap((event: OAuthEvent) => {
          if (event instanceof OAuthSuccessEvent) {
            if (event.type === OAUTH_EVENT_TYPES.discovery_document_loaded) this.onOidcModuleSetup();
            if (event.type === OAUTH_EVENT_TYPES.session_changed) this.sessionChanged();
          } else if (event instanceof OAuthErrorEvent) {
            console.error('AppComponent OAuth error:', event);
            this.oAuthService.tryLogin();
          }
        })
      )
      .subscribe();
  }

  private sessionChanged() {
    this.storageService.clearStorage();
    this.storageService.writeRaw('redirect', window.location.pathname);
    this.storageService.writeRaw('queryString', window.location.search);
    window.location.href = '/deconnexion.html';
  }

  private onOidcModuleSetup() {
    // Behavior currently disabled as no specs where provided for it.
    // const prevStateStored = localStorage.getItem('gs1-ecli-previous-state');
    const currentURL = window.location.href;

    if (currentURL.indexOf('apim/connexion') === -1) localStorage.removeItem('gs1-ecli-state-apim');
    if (currentURL.indexOf('/standard') === -1) localStorage.removeItem('tokenAdmin');
    if (currentURL.indexOf('standard/details') === -1) localStorage.removeItem('gs1-ecli-standard-state');
    if (currentURL.indexOf('factures') === -1 || currentURL.indexOf('codes') === -1) localStorage.removeItem('gs1-ecli-route-state');

    // Behavior currently disabled as no specs where provided for it.
    // if (prevStateStored) {
    //   localStorage.removeItem('gs1-ecli-previous-state');
    //   const prevState = JSON.parse(prevStateStored);
    //   this.router.navigateByUrl(prevState.url);
    // }
  }

  ngOnDestroy(): void {
    this.storageService.resetStorage();
  }
}
